import { useCallback } from "react";
import useAuthStore from "@/store/use-auth-store";
import { useToast } from "@/features/toast";

/**
 * Hook for refreshing user data
 * Provides a simple interface to refresh user data with proper error handling
 */
export const useUserRefresh = () => {
  const { refreshUserData, isAuthenticated } = useAuthStore();
  const { error } = useToast();

  const refreshUser = useCallback(
    async (options?: {
      showErrorToast?: boolean;
      silent?: boolean;
      force?: boolean;
    }) => {
      const {
        showErrorToast = false,
        silent = false,
        force = false,
      } = options || {};

      if (!isAuthenticated()) {
        if (!silent) {
          console.warn("Cannot refresh user data: not authenticated");
        }
        return false;
      }

      try {
        await refreshUserData(force);

        return true;
      } catch (refreshError: any) {
        if (!silent) {
          console.error("❌ Failed to refresh user data:", refreshError);
        }

        if (showErrorToast) {
          error("Kullanıcı bilgileri güncellenemedi", {
            title: "Hata",
          });
        }

        return false;
      }
    },
    [refreshUserData, isAuthenticated, error]
  );

  return {
    refreshUser,
    isAuthenticated: isAuthenticated(),
  };
};
